import React from 'react';
import SelectComponent from "../../../../components/select/select-component.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";

const Filters = ({ setFilters, filters }) => {
    const {documentExpirationTeam} = useReportFiltersFetch({fetchDocumentExpirationTeam: true})

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <SelectComponent
                        id={'documentType'}
                        label='Tipo de documento'
                        options={[
                            {label: "CNH", value: "expirationCnh"},
                            {label: "Porte de arma", value: "carryDueDate"},
                            {label: "CRAF", value: "crafDueDate"},
                            {label: "Exame psicológico", value: "psychoDueDate"},
                            {label: "Exame de tiro", value: "shotDueDate"},
                            {label: "Certificado de reservista", value: "reservistDate"},
                            {label: "Habilitação para arma longa", value: "longGunLicenceDueDate"},
                            {label: "Exame toxicológico", value: "toxicologicalDueDate"}
                        ]}
                        value={filters.documentType}
                        onChange={(value) => setFilters(prev => ({...prev, documentType: value}))}
                        classNameWrapper={"w-full"}
                        isMulti={true}
                    />

                    <SelectComponent
                        id={'team'}
                        label='Equipe'
                        options={documentExpirationTeam}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                        classNameWrapper={"w-full"}
                        isMulti={true}
                    />

                    <AccessForm filters={filters} setFilters={setFilters} valueAsId={true}/>

                </form>
            </div>
        </>
    );
};

export default Filters;